import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { M as b, a as c, b as g, c as h } from "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import { Button as C } from "./button.js";
import { r as x, Q as o, f as d, s as u, b as y, c as $ } from "./themes-5f0b3c3d.mjs";
import { l as r } from "./lineHeights-72d3110c.mjs";
import { t as n } from "./textStyles-42cab346.mjs";
import "react";
import { u as t } from "./index-6a632112.mjs";
import { TabList as S, TabPanel as k } from "./tabs.js";
const w = t(b)`
  border-radius: ${x["4x"]};
  margin: auto;

  min-height: 200px;
  padding-top: 5px;

  @media ${o.tabletAndUp} {
    max-height: 704px;
    max-width: 600px;
    min-width: 100px;
  }
`, T = t.div`
  position: relative;

  @media ${o.tabletAndUp} {
    max-width: 600px;
  }
`, v = t(c)`
  @media ${o.tabletAndUp} {
    padding: 10px 0;
  }
  div:nth-of-type(2) {
    @media ${o.mobile} {
      position: unset;
      top: unset;
      color: unset;
    }
  }
`, M = t(g)``, U = t(h)``, A = t.span`
  display: none;
  flex-direction: row;
  justify-content: space-between;
  color: var(--text-default, #00142e);
  font-family: ${d.inter};
  font-size: ${n.body.medium.m.fontSize};
  font-style: normal;
  font-weight: ${n.body.medium.m.fontWeight};
  line-height: ${r.medium};
  padding-bottom: ${u["2x"]};

  @media ${o.tabletAndUp} {
    display: flex;
  }
`, B = t.div`
  color: var(--text-subtle, #38485c);
  font-family: ${d.inter};
  font-size: ${n.body.medium.m.fontSize};
  font-style: normal;
  font-weight: ${n.body.regular.m.fontWeight};
  line-height: ${r.medium};
`, z = t(S)`
  border-bottom: ${y["1x"]} solid ${$.brandTwilight[400]};
  display: none;
  @media ${o.tabletAndUp} {
    display: flex;
  }
`, H = t(k)`
  padding-top: 1px;
`;
function e({
  openCookieSettings: s,
  closeCookieSettigs: a,
  children: m,
  idProps: l,
  accessibilityOptions: p
}) {
  return /* @__PURE__ */ f(
    w,
    {
      isOpen: s,
      onClose: a,
      variant: "small",
      children: [
        /* @__PURE__ */ i(
          v,
          {
            idProps: l,
            accessibilityOptions: p,
            onClose: a,
            children: "Cookie Settings"
          }
        ),
        /* @__PURE__ */ i(M, { children: m }),
        /* @__PURE__ */ i(U, { children: /* @__PURE__ */ i(C, { onClick: a, children: "Confirm My Choices" }) })
      ]
    }
  );
}
e.Container = T;
e.ContentHeader = A;
e.ContentBody = B;
e.TabList = z;
e.TabPanel = H;
export {
  e as C
};
